module.exports = __webpack_public_path__ + "static/media/display_blue.d434e747.png";